// simpleTextGenerator.js
// NextScenes realistic generator (200–500 words)

export function generateText(paragraphs = 4) {

  const subjects = [
    "Didie",
    "The old man",
    "The stranger",
    "The young woman",
    "The court clerk",
    "The guard",
    "The boy",
    "The visitor"
  ];

  const actions = [
    "entered the room quietly",
    "looked at the door without moving",
    "sat down and waited",
    "held the letter in his hand",
    "listened carefully",
    "turned toward the sound",
    "watched everything",
    "remained silent for a long time"
  ];

  const thoughts = [
    "He knew something important was about to happen.",
    "He did not trust what he was seeing.",
    "Nothing felt the same anymore.",
    "He wondered if he had made a mistake.",
    "He felt the weight of the moment.",
    "He could not explain his fear.",
    "He knew there was no turning back.",
    "He understood the truth now."
  ];

  const fillers = [
    "The air was heavy and difficult to breathe.",
    "Outside, the world continued as if nothing had changed.",
    "Time seemed to slow down around him.",
    "He remembered something he had tried to forget.",
    "Every small sound made him uneasy.",
    "He remained still, thinking carefully.",
    "He was not ready for what would come next.",
    "Silence filled the space between them."
  ];

  function pick(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
  }

  function makeSentence() {
    return (
      pick(subjects) + " " +
      pick(actions) + ". " +
      pick(thoughts) + " " +
      pick(fillers)
    );
  }

  let text = [];

  for (let p = 0; p < paragraphs; p++) {

    let paragraph = [];

    const sentences = 8 + Math.floor(Math.random() * 6); // 8–14 sentences

    for (let i = 0; i < sentences; i++) {
      paragraph.push(makeSentence());
    }

    text.push(paragraph.join(" "));
  }

  return text.join("\n\n");
}